import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/auth/Login.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/delete_profile",
      name: "DeleteProfile",
      component: () => import("@/views/auth/DeleteProfile.vue"),
      meta: {
        layout: "full",
      },
    },


    {
      path: "/forgotPassword",
      name: "ForgotPassword",
      component: () => import("@/views/auth/ForgotPassword.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/verification",
      name: "VerificationCode",
      component: () => import("@/views/auth/VerificationCode.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },
    {
      path: "/newPassword",
      name: "NewPassword",
      component: () => import("@/views/auth/NewPassword.vue"),
      props: true,
      meta: {
        layout: "full",
      },
    },

    {
      path: "/profile",
      name: "Profile",
      component: () => import("@/views/profile/Profile.vue"),
      meta: {
        pageTitle: "My Profile",
        breadcrumb: [
          {
            text: "My Profile",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },
    {
      path: "/changePassword",
      name: "ChangePassword",
      component: () => import("@/views/auth/ChangePassword.vue"),
      meta: {
        pageTitle: "Change Password",
        breadcrumb: [
          {
            text: "Change Password",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "update_user",
      },
    },

    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("@/views/dashboard/DashboardWrapper.vue"),
      meta: {
        pageTitle: "Dashboard",
        breadcrumb: [
          {
            text: "Dashboard",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },

    {
      path: "/signup",
      name: "Signup",
      component: () => import("@/views/auth/Signup.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/signupConfirmation",
      name: "SignupConfirmation",
      component: () => import("@/views/auth/SignupConfirmation.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/user",
      name: "User",
      component: () => import("@/views/user/User.vue"),
      meta: {
        pageTitle: "User",
        breadcrumb: [
          {
            text: "User",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_user",
      },
    },
    {
      path: "/role",
      name: "Role",
      component: () => import("@/views/role/Role.vue"),
      meta: {
        pageTitle: "Role",
        breadcrumb: [
          {
            text: "Role",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_role",
      },
    },
    

    {
      path: "/subscription_plan",
      name: "SubscriptionPlan",
      component: () => import("@/views/subscription_plan/SubscriptionPlan.vue"),
      meta: {
        pageTitle: "Subscription Plans",
        breadcrumb: [
          {
            text: "Subscription Plans",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },

    {
      path: "/lead",
      name: "Lead",
      component: () => import("@/views/lead/Lead.vue"),
      meta: {
        pageTitle: "Leads",
        breadcrumb: [
          {
            text: "Leads",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },


    {
      path: "/customer",
      name: "Customer",
      component: () => import("@/views/customer/Customer.vue"),
      meta: {
        pageTitle: "Customers",
        breadcrumb: [
          {
            text: "Customers",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },

    {
      path: "/agent_subscription",
      name: "AgentSubscription",
      component: () => import("@/views/agent_subscription/AgentSubscription.vue"),
      meta: {
        pageTitle: "Agent Subscription",
        breadcrumb: [
          {
            text: "Agent Subscription",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },


    {
      path: "/ai_call_log",
      name: "AICallLog",
      component: () => import("@/views/ai_call_log/AICallLog.vue"),
      meta: {
        pageTitle: "AI Call Logs",
        breadcrumb: [
          {
            text: "AI Call Logs",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },


    {
      path: "/state",
      name: "State",
      component: () => import("@/views/state/State.vue"),
      meta: {
        pageTitle: "States",
        breadcrumb: [
          {
            text: "States",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },

    {
      path: "/campaign",
      name: "Campaign",
      component: () => import("@/views/campaign/CampaignView.vue"),
      meta: {
        pageTitle: "Campaign Management",
        breadcrumb: [
          {
            text: "Campaign",
            active: true,
          },
        ],
        requiresAuth: true,
      },
    },

    {
      path: "*",
      redirect: "/login",
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
